<template>
    <div v-if="form.status === 3" class="detail-card green">
        <div class="card-header">
            <div class="title">完成</div>
        </div>
        <div class="card-body">
            <spec-view>
                <spec-item label="完成人">
                    {{ getCompleteMarker() }}
                </spec-item>
                <spec-item label="完成日期">
                    {{ form.bnK_DAT | dateFormater("YYYY-MM-dd") }}
                </spec-item>
                <spec-item label="收款天數" tip="開立日期 - 完成日期">
                    {{ getMoneyDays() }}
                </spec-item>
            </spec-view>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
    },
    components: { SpecView, SpecItem },
    methods: {
        getMoneyDays() {
            const SDAT = this.form.bnK_DAT;
            if (!SDAT || !this.form.foO_DAT) return '--';
            const a = moment(SDAT);
            const b = moment(this.form.foO_DAT);
            return a.diff(b, 'days');
        },
        getCompleteMarker() {
            const MARKER = _.find(this.form.audits, ['menU_UNT', 'B03']);
            return MARKER.stF_NAM || '--';
        },
    },
};
</script>
